import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-resources-limits-dialog",
  standalone: true,
  imports: [ButtonModule, DialogModule, TranslateModule, CommonModule],
  templateUrl: "./resources-limits-dialog.component.html",
  styleUrl: "./resources-limits-dialog.component.scss",
})
export class ResourcesLimitsDialogComponent {
  @Input() visible: boolean | undefined;
  @Input() productType: string | undefined;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  householdCategories: string[] = [
    "onePerson",
    "twoPeople",
    "threePeople",
    "fourPeople",
    "fivePeople",
    "sixPeople",
    "additionalPerson",
  ];

  closeDialog() {
    this.close.emit();
  }
}
